import React, { useState } from "react";
import { Grid, Paper, Typography, IconButton } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import ServiceEdit from "../../../styles/svg/service-edit.svg";
import Switch from "./Switch";
import useCustomMutate from "../../../hooks/useMutate";
import { updateService } from "../../../sevices/serviceApi";
import FormDialog from "../../../components/Dialog/FormDialog";
import CreateService from "./CreateService";

function Service({ item }) {
  const { mutate } = useCustomMutate(updateService, ["service"]);
  const [anchorEl, setAnchorEl] = useState(false);

  const handleClose = () => {
    setAnchorEl(false);
  };
  const handleClick = () => {
    setAnchorEl(true);
  };

  const callback = (status) => {
    mutate({
      data: { is_active: status, name: item.name },
      id: item.service_id,
    });
  };
  return (
    <>
      {anchorEl && (
        <FormDialog
          open={anchorEl}
          handleClose={handleClose}
          title={"Edit Service"}
          btnTitle={"Confirm"}
        >
          <CreateService onClose={handleClose} isEdit={true} item={item} />
        </FormDialog>
      )}
      <Paper
        className="service-paper d-flex justify-content-space-between align-items-center"
      >
        <div className="d-flex align-items-center"><DragIndicatorIcon className="drag-icon"/>
        <Typography className="service-name ">{item.name}</Typography></div>
        <div className="d-flex align-items-center">
          <Switch defaultValue={item.is_active} callback={callback} />
          <IconButton color="success" onClick={handleClick}>
            <img src={ServiceEdit} />
          </IconButton>
        </div>
      </Paper>
    </>
  );
}

export default Service;
